import {LanguageDto} from '../../Models/Shared/language.interface';

export const AVAILABLE_LANGUAGES_CONST: LanguageDto[] = [
  { code: 'es', name: 'CONST.LANGUAGES.SPANISH', flag: '' },
  { code: 'en', name: 'CONST.LANGUAGES.ENGLISH', flag: '' },
  { code: 'it', name: 'CONST.LANGUAGES.ITALIAN', flag: '' },
  { code: 'pt', name: 'CONST.LANGUAGES.PORTUGUESE', flag: '' },
];
